<template>
  <div class="admin-exclusive-order-controls" aria-label="Controles de ordenacao">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          small
          class="admin-exclusive-icon-btn"
          :disabled="disabled || isFirst"
          :aria-label="`Mover ${projectName} para cima`"
          v-bind="attrs"
          v-on="on"
          @click="$emit('move-up')"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>
      <span>Mover para cima</span>
    </v-tooltip>

    <span class="admin-exclusive-order-controls__position" aria-label="Posicao atual">
      {{ displayPosition }}
    </span>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          small
          class="admin-exclusive-icon-btn"
          :disabled="disabled || isLast"
          :aria-label="`Mover ${projectName} para baixo`"
          v-bind="attrs"
          v-on="on"
          @click="$emit('move-down')"
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <span>Mover para baixo</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "AdminExclusiveProjectOrderControls",
  props: {
    position: { type: Number, required: true },
    total: { type: Number, required: true },
    projectName: { type: String, default: "obra" },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    displayPosition() {
      return String(this.position).padStart(2, "0");
    },
    isFirst() {
      return this.position <= 1;
    },
    isLast() {
      return this.position >= this.total;
    },
  },
};
</script>

<style src="../../../styles/home-page/admin.css"></style>
